import { ModulesState } from "fabrix/redux/module-slice";
import { AppState } from "fabrix/redux/store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

export interface FabrixNavigateParam {
    [key: string]: any;
}

/**
 * Creates a navigation helper that routes to module pages by name and path segments.
 * @returns Function accepting module name, page path, and query parameters.
 */
export function useFabrixNavigate() {

    const navigate = useNavigate();
    const _modules = useSelector<AppState>(state => state.modules) as ModulesState;

    const fabrixNavigate = (moduleName: string, page?: string[] | string, parameters?: FabrixNavigateParam[]) => {
        let module = _modules.modules.find(x => x.name.toLowerCase() === moduleName.toLowerCase())
        let url = '';
        if (module) {
            url = `${url}${module.path}`
        }
        if (Array.isArray(page)) {
            url = `${url}/${page.join("/")}`
        } else {
            url = `${url}/${page}`
        }

        if (parameters) {
            let params = parameters.map(x => `${x.name}=${x.value}`).join("&")
            url = `${url}?${params}`
        }

        navigate(url);

    }

    return fabrixNavigate;

}



/**
 * Produces a navigation helper scoped to the current module path.
 * @returns Function that navigates within the module, supporting query params and new tabs.
 */
export function useModuleNavigate() {

    const navigate = useNavigate();


    const moduleNavigate = (page?: string[] | string, parameters?: FabrixNavigateParam, state?: any, newTab?: boolean) => {

        let location = window.location.pathname;
        let locationParts = location.split("/")



        let url = '/';
        if (module) {
            url = `${url}${locationParts[1]}`
        }

        if (page) {
            if (Array.isArray(page)) {
                url = `${url}/${page.join("/")}`
            } else {
                if (page.startsWith("/"))
                    page = page.substring(1)
                url = `${url}/${page}`
            }

            if (parameters) {
                let params = new Array<string>();
                for (const [key, value] of Object.entries(parameters)) {
                    params.push(`${key}=${value}`)
                }
                url = `${url}?${params}`
            }
        }

        if (newTab) {
            // React Router state is not available in a new tab.
            window.open(url || "/", "_blank", "noopener,noreferrer");
        } else {
            navigate(url || "/", { state });
        }

    }

    return moduleNavigate;

}